export default {
  getIncome360pay(state) {
    return state.income360pay;
  },
};
